import React, { useEffect, useRef, useState } from 'react';
import { TERMS_OF_USE_TEXT } from '../constants/options';

/**
 * Modal with the terms of use. The accept button is only enabled after the user
 * scrolls to the end of the text (or immediately if the text fits without scrolling).
 */
export const TermsModal = ({ onAccept, onClose }) => {
    const bodyRef = useRef(null);
    const [reachedEnd, setReachedEnd] = useState(false);

    const checkScroll = () => {
        const el = bodyRef.current;
        if (el && el.scrollTop + el.clientHeight >= el.scrollHeight - 8) {
            setReachedEnd(true);
        }
    };

    useEffect(() => {
        checkScroll();
    }, []);

    return (
        <div className="psp-modal-backdrop" role="dialog" aria-modal="true" aria-labelledby="psp-terms-title">
            <div className="psp-modal psp-fade-in">
                <div className="psp-modal__header">
                    <h2 id="psp-terms-title">Termos de Uso</h2>
                </div>
                <div
                    ref={bodyRef}
                    className={`psp-modal__body${TERMS_OF_USE_TEXT ? '' : ' psp-modal__body--placeholder'}`}
                    onScroll={checkScroll}
                    tabIndex={0}
                >
                    {TERMS_OF_USE_TEXT || 'O texto dos termos de uso será incluído aqui.'}
                </div>
                <div className="psp-modal__footer">
                    <span className="psp-field__hint">
                        {reachedEnd ? 'Leitura concluída.' : 'Role até o final para liberar o aceite.'}
                    </span>
                    <div className="psp-actions">
                        <button type="button" className="psp-btn psp-btn--outline psp-btn--inline" onClick={onClose}>
                            Fechar
                        </button>
                        <button
                            type="button"
                            className="psp-btn psp-btn--primary psp-btn--inline"
                            disabled={!reachedEnd}
                            onClick={onAccept}
                        >
                            Li e aceito
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

/**
 * Required checkbox for accepting the terms. It can only be checked through the modal.
 */
const TermsCheckbox = ({ accepted, onChange, error }) => {
    const [open, setOpen] = useState(false);

    return (
        <div className="psp-field">
            <div className="psp-terms">
                <input
                    id="psp-terms-accepted"
                    type="checkbox"
                    checked={accepted}
                    onChange={(event) => {
                        if (accepted) onChange(false);
                        else {
                            event.preventDefault();
                            setOpen(true);
                        }
                    }}
                    aria-invalid={!!error}
                />
                <label htmlFor="psp-terms-accepted">
                    Li e aceito os{' '}
                    <button type="button" className="psp-link" onClick={() => setOpen(true)}>
                        termos de uso
                    </button>
                    <span className="psp-required">*</span>
                </label>
            </div>
            {error && (
                <span className="psp-field__error" role="alert">
                    {error}
                </span>
            )}
            {open && (
                <TermsModal
                    onClose={() => setOpen(false)}
                    onAccept={() => {
                        onChange(true);
                        setOpen(false);
                    }}
                />
            )}
        </div>
    );
};

export default TermsCheckbox;
